import AddFile from './AddFile'
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import {  useParams } from 'react-router-dom';
import { useRef, useState, useEffect, forwardRef } from 'react';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios';
const AddFiles = (props) => {
  
  const onCancel = props.onCancel;
  const onUpload = props.onUpload;
  
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [defaultType, setDefaultType] = useState('');

  const handleFilesChanged = (event) => {
    setSelectedFiles([...selectedFiles, ...Array.from(event.target.files)]);
  };
  
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display:'block',
    overflow:'scroll',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height: '80%',
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 10,
    p: 4,
  };

  return(

      <Modal
        open={true}
        onClose={onCancel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form>
          <Box sx={modalStyle}>
            <h1>
              Upload Case Files
            </h1>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <InputLabel id="add-filename-label">Add Files *</InputLabel>
                <TextField 
                  type="file" 
                  onChange={handleFilesChanged} 
                    inputProps={{
                      multiple: true
                    }}
                  fullWidth 
                  />
              </Grid>
            <Grid item xs={12}>
              <InputLabel id="type-label">Default File Type *</InputLabel>
              <Select
                labelId="doc-type-label"
                name="type"
                value={defaultType}
                onChange={(event) => {setDefaultType(event.target.value)}}
                fullWidth
                required >
                  <MenuItem value={''}></MenuItem>
                  <MenuItem value={'repair_order'}>Repair Order</MenuItem>
                  <MenuItem value={'purchase_contract'}>Purchase Contract</MenuItem>
                  <MenuItem value={'lease_agreement'}>Lease Agreement</MenuItem>
                  <MenuItem value={'warranty_info'}>Warranty Info</MenuItem>
                  <MenuItem value={'other'}>Other</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12}>
            </Grid>
              <Grid item xs={12}>
                <h2>Pending Files</h2>
                <Divider sx={{mb: 2}} />
                {selectedFiles.map((fileInfo,index ) => <AddFile defaultType={defaultType} fileData={fileInfo} fileName={fileInfo.name} onUpload={onUpload}   />)} 
              </Grid>
            </Grid>
          </Box>
        </form>
    </Modal>)
}
export default AddFiles;
